export const locale = {
    id: 'en-US'
}
